import { render } from "./ReputGlobalRisk.vue?vue&type=template&id=25915d81"
import script from "./ReputGlobalRisk.vue?vue&type=script&lang=js"
export * from "./ReputGlobalRisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__